var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6ad4d14ac3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.5 3.011719 L 332.011719 3.011719 L 332.011719 308.898438 L 28.5 308.898438 Z M 28.5 3.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "365cf9349d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128.382812 322.421875 L 232 322.421875 L 232 374.25 L 128.382812 374.25 Z M 128.382812 322.421875 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ad4d14ac3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 330.519531 295.570312 L 300.277344 256.953125 C 294.667969 249.785156 291.617188 240.945312 291.617188 231.835938 L 291.617188 146.53125 L 291.601562 146.53125 C 290.914062 92.566406 251.855469 47.859375 200.453125 38.441406 L 200.453125 23.890625 L 200.417969 23.890625 C 200.425781 23.664062 200.453125 23.441406 200.453125 23.207031 C 200.453125 12.050781 191.410156 3.007812 180.253906 3.007812 C 169.101562 3.007812 160.058594 12.050781 160.058594 23.207031 C 160.058594 23.441406 160.085938 23.664062 160.089844 23.890625 L 160.058594 23.890625 L 160.058594 38.441406 C 108.65625 47.859375 69.597656 92.566406 68.914062 146.53125 L 68.894531 146.53125 L 68.894531 231.835938 C 68.894531 240.945312 65.84375 249.785156 60.230469 256.953125 L 29.992188 295.570312 C 26.160156 301.164062 30.15625 308.761719 36.941406 308.761719 L 323.570312 308.761719 C 330.347656 308.761719 334.351562 301.164062 330.519531 295.570312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#365cf9349d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 180.253906 374.257812 C 208.617188 374.257812 231.605469 351.265625 231.605469 322.910156 L 128.910156 322.910156 C 128.910156 351.265625 151.894531 374.257812 180.253906 374.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.589a8133fcca556ab618ea2b740122cf.svg";
export { ForwardRef as ReactComponent };